export const avatar = theme => ({
  '& > svg': {
    color: theme.palette.primary.dark,
  },
  backgroundColor: theme.palette.primary.light,
  height: 32,
  width: 32,
});

export const featureItemsContainer = theme => ({
  '&:last-child': {
    paddingBottom: theme.spacing(2),
  },
  alignItems: 'flex-start',
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  width: '100%',
});

export const infoIcon = theme => ({
  color: theme.palette.secondary.main,
  height: 12,
  marginLeft: 9,
  width: 12,
});

export const recommendedBanner = (theme, isSelected) => ({
  alignItems: 'center',
  backgroundColor: theme.palette.primary.lighter,
  borderLeft: isSelected ? `2px solid ${theme.palette.secondary.medium}` : 'none',
  borderRight: isSelected ? `2px solid ${theme.palette.secondary.medium}` : 'none',
  borderTop: isSelected ? `2px solid ${theme.palette.secondary.medium}` : '2px solid transparent',
  display: 'flex',
  height: 24,
  justifyContent: 'center',
  marginBottom: theme.spacing(1),
  width: '100%',
});

export const selectButton = (theme, isSelected) => ({
  backgroundColor: isSelected ? theme.palette.secondary.light : 'transparent',
  width: 104,
});

export const selectedBorder = theme => ({
  border: `2px solid ${theme.palette.secondary.medium}`,
  height: '100%',
  position: 'absolute',
  top: 0,
  width: '100%',
});

export const subscriptionBundleCardWrapper = (theme, currentUsage, isRecommended) => ({
  [theme.breakpoints.down('lg')]: {
    minWidth: 295,
    width: 295,
  },
  '&:last-child': {
    marginRight: 0,
  },
  alignItems: 'center',
  borderRadius: 0,
  boxShadow: theme.shadows[5],
  boxSizing: 'border-box',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  minWidth: 216,
  paddingBottom: currentUsage ? 0 : theme.spacing(4),
  paddingTop: isRecommended ? 0 : theme.spacing(4),
  position: 'relative',
  scrollSnapAlign: 'center',
  scrollSnapStop: 'always',
  width: 216,
});
